import { observable, action } from 'mobx'

import { IBaseListAddOptions } from './BaseListStore'
import PersistenceStore from 'stores/persistence/PersistenceStore'
import { ITableName } from 'stores/persistence/types'

export interface IBaseListItemUpdateOptions extends IBaseListAddOptions {}

export interface IBaseListItem {
  id: string | number
  idbTableName: ITableName | null
  update: (payload: any, options: IBaseListItemUpdateOptions) => void
  serialize: () => any
}

export default class BaseListItem implements IBaseListItem {
  @observable id: string | number
  @observable idbTableName!: ITableName // `!` because `idbTableName` is not initialized here, it will be set by BaseListStore (sorry whoever's reading this)

  constructor(item: { id: string | number }) {
    this.id = item.id
  }

  @action
  update(
    payload: any,
    { skipPersist = false }: IBaseListItemUpdateOptions = {}
  ) {
    // If the `idbTableName` variable is set, also persist to IndexedDB
    if (!skipPersist && this.idbTableName) {
      const toSave = this.serialize()
      const keysToSave = Object.keys(toSave)
      const changedKeys = Object.keys(payload)
      const allCandidateKeys = new Set([...keysToSave, ...changedKeys])

      if (allCandidateKeys.size !== keysToSave.length + changedKeys.length) {
        // This essentially checks if the update payload has keys that might be included when serialized.
        // This will make sure persistence does not occur when a key that is not serialized is updated. Saves unnecessary calls to IndexedDB
        this.forceUpdate()
      }
    }
  }

  @action
  forceUpdate = async () => {
    await PersistenceStore.save(this.idbTableName, this.serialize())
  }

  /*
   * Retuns a POJO based on this instance's members. The result of this is also saved to IndexedDB, if requested
   */
  serialize(): any {}
}
